import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from '../../../services/config.service';
import {RequestService} from '../../../services/request.service';
import {SessionService} from '../../../services/session.service';
import {Http} from '@angular/http';

@Injectable()
export class CertificateService{
  constructor(
    private http: Http,
    private sessionService: SessionService,
    private requestService: RequestService,
    private configService: ConfigService
  ) {}

  getCertificateHtml(certificate: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.preview.api;
    return this.requestService.post(url, certificate, true);
  }

  getCertificateDownloadLink(certificate: any): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.download.api;
    return this.requestService.post(url, certificate, true);
  }

  getCertificateFile(url: string, fileName?: string): Observable<any> {
    return this.requestService.getWithoutXitpxDomain(url,  'blob', false, fileName);
  }

  getCertificates(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.list.api + '?filter=' + assignmentId;
    return this.requestService.get(url);
  }

  getElearningCertificates(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.listElearning.api + '/' + assignmentId;
    return this.requestService.get(url);
  }

  getElearningCertificateHtml(certificateId: string): Observable<any>{
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.previewElearning.api + '/' + certificateId;
    return this.requestService.get(url);
  }

  getElearningCertificateDownloadLink(certificateId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.downloadElearning.api + '/' + certificateId;
    return this.requestService.get(url);
  }

  getExamCertificateDownloadLink(assignmentId: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.certificates.downloadExam.api + '/'  + assignmentId;
    return this.requestService.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/certificate/certificate.service.ts